import React from 'react';
import { LoanForm } from './pages/LoanForm';
export function App() {
  return <LoanForm data-id="element-0" data-mp="35cby6hh7m18u" />;
}